"use client";

import { useEffect, useRef } from "react";

export default function ProteinViewer({
  pdbUrl,
}: {
  pdbUrl: string | null;
}) {
  const viewerRef = useRef<HTMLDivElement | null>(null);
  const frameRef = useRef<number | null>(null);

  useEffect(() => {
    if (!pdbUrl || !viewerRef.current) return;

    let viewer: any;
    let mounted = true;

    async function init() {
      // 🔒 Client-only dynamic import
      const $3Dmol = await import("3dmol");

      if (!mounted || !viewerRef.current) return;

      viewerRef.current.innerHTML = "";

      viewer = $3Dmol.createViewer(viewerRef.current, {
        backgroundColor: "#ffffff",
        antialias: true,
      });

      const res = await fetch(pdbUrl);
      const pdb = await res.text();

      viewer.addModel(pdb, "pdb");

      viewer.setStyle(
        {},
        {
          stick: { radius: 0.3, colorscheme: "Jmol" },
          sphere: { scale: 0.7 },
        }
      );

      viewer.zoomTo();
      viewer.render();

      // 🔄 Smooth auto-rotation
      const spin = () => {
        if (!mounted) return;
        viewer.rotate(0.4, "y");
        viewer.render();
        frameRef.current = requestAnimationFrame(spin);
      };

      spin();
    }

    init();

    return () => {
      mounted = false;
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
      viewer?.clear?.();
    };
  }, [pdbUrl]);

  return (
    <div
      ref={viewerRef}
      className="w-full h-[600px] rounded-xl bg-white border overflow-hidden"
    />
  );
}
